import 'whatwg-fetch';
import { checkStatus, authorization } from 'actions/utils/fetch_utils';
import { apiBasename } from 'actions/config/api';

export const fetchConfigValues = () => {
	return fetch(apiBasename + '/configValue', authorization())
	.then(checkStatus)
	.then((res) => res.json());
};
